import React from 'react';
import SettingsSaveButton from '../SettingsSaveButton';
import MotorBrandSettingsCard from '../MotorBrandSettingsCard';
import { useLanguage } from '../../../../i18n/LanguageContext';

const DikeySettings = React.memo(({
  activeTypeTab,
  dikeyExtras,
  setDikeyExtras,
  dikeyPvcExtras,
  setDikeyPvcExtras,
  dikeyStorExtras,
  setDikeyStorExtras,
  isFonListCollapsed,
  setIsFonListCollapsed,
  newDikeyFonName,
  setNewDikeyFonName,
  editingDikeyFonName,
  setEditingDikeyFonName,
  handleSaveSettings,
  isSavingSettings
}) => {
  const { t } = useLanguage();
  const isPerde = activeTypeTab === 'dikeyPerde';

  const extras = isPerde
    ? dikeyExtras
    : activeTypeTab === 'dikeyPvc'
      ? dikeyPvcExtras
      : dikeyStorExtras;
  const setExtras = isPerde
    ? setDikeyExtras
    : activeTypeTab === 'dikeyPvc'
      ? setDikeyPvcExtras
      : setDikeyStorExtras;

  const motorTitle = activeTypeTab === 'dikeyPerde'
    ? t('productList.extraPrices.dikeyPerdeMotorTitle', 'Dikey Perde Motor ve Kumanda Ayarları')
    : activeTypeTab === 'dikeyPvc'
      ? t('productList.extraPrices.dikeyPvcMotorTitle', 'Dikey PVC Motor ve Kumanda Ayarları')
      : t('productList.extraPrices.dikeyStorMotorTitle', 'Dikey Stor Motor ve Kumanda Ayarları');

  const motorSubtitle = activeTypeTab === 'dikeyPerde'
    ? t('productList.extraPrices.dikeyPerdeMotorSubtitle', 'Dikey Perde siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri')
    : activeTypeTab === 'dikeyPvc'
      ? t('productList.extraPrices.dikeyPvcMotorSubtitle', 'Dikey PVC siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri')
      : t('productList.extraPrices.dikeyStorMotorSubtitle', 'Dikey Stor siparişlerinde kullanılacak 3 motor firmasının motor ve kumanda ücretleri');

  return (
    <>
      <MotorBrandSettingsCard
        title={motorTitle}
        subtitle={motorSubtitle}
        productType={activeTypeTab}
        extras={extras}
        setExtras={setExtras}
        handleSaveSettings={handleSaveSettings}
        isSavingSettings={isSavingSettings}
      />

      {isPerde && (
        <div className="settings-card settings-card--accordion">
          <div
            className="settings-accordion-header"
            onClick={() => setIsFonListCollapsed(!isFonListCollapsed)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === 'Enter' && setIsFonListCollapsed(!isFonListCollapsed)}
          >
            <div className="settings-card-title">
              <i className="fas fa-arrows-alt-v"></i>
              <div className="settings-card-title-text">
                <h4>{t('productList.dikeySettings.fonTitle', 'Dikey Perde Fon Ayarları')}</h4>
                <span className="settings-card-subtitle">
                  {t('productList.dikeySettings.fonSubtitle', 'Fon ücreti ve fon isimleri listesi')}
                </span>
              </div>
            </div>
            <div className="settings-accordion-actions">
              <SettingsSaveButton
                onClick={(e) => {
                  e.stopPropagation();
                  handleSaveSettings();
                }}
                isSaving={isSavingSettings}
                variant="compact"
              />
              <i className={`fas fa-chevron-${isFonListCollapsed ? 'down' : 'up'} settings-accordion-chevron`}></i>
            </div>
          </div>

          {!isFonListCollapsed && (
            <div className="settings-accordion-content">
              <div className="settings-inline-price-row">
                <div className="settings-inline-price-label">
                  <i className="fas fa-coins"></i>
                  <span>{t('productList.dikeySettings.fonPriceM2', 'Dikey Perde Fon Ücreti (m²)')}</span>
                </div>
                <div className="settings-input-wrap settings-input-wrap--sm">
                  <input
                    type="number"
                    value={dikeyExtras.fon}
                    onChange={(e) => setDikeyExtras(p => ({ ...p, fon: e.target.value }))}
                    placeholder="0"
                  />
                  <span className="settings-input-suffix">€</span>
                </div>
              </div>

              <div className="settings-column">
                <h5 className="settings-section-label">
                  <i className="fas fa-list"></i> {t('productList.dikeySettings.fonNamesList', 'Fon İsimleri Listesi')}
                </h5>
                <div className="list-add-form">
                  <input
                    type="text"
                    placeholder={t('productList.dikeySettings.newFonPlaceholder', 'Yeni Fon Adı (Örn: Fon 1)')}
                    value={newDikeyFonName}
                    onChange={(e) => setNewDikeyFonName(e.target.value)}
                  />
                  <button
                    type="button"
                    onClick={() => {
                      if (!newDikeyFonName) return;
                      const newList = [...(dikeyExtras.fonList || []), newDikeyFonName];
                      setDikeyExtras({ ...dikeyExtras, fonList: newList });
                      setNewDikeyFonName('');
                      handleSaveSettings({ dikeyFonList: newList });
                    }}
                  >
                    <i className="fas fa-plus"></i>
                  </button>
                </div>

                <div className="settings-list-container">
                  {(!dikeyExtras.fonList || dikeyExtras.fonList.length === 0) ? (
                    <div className="settings-list-empty">{t('productList.dikeySettings.emptyList', 'Liste boş')}</div>
                  ) : (
                    <ul className="settings-inner-list">
                      {dikeyExtras.fonList.map((item, index) => (
                        <li key={index} className="settings-list-item">
                          {editingDikeyFonName.index === index ? (
                            <div className="edit-mode-container">
                              <input
                                type="text"
                                value={editingDikeyFonName.value}
                                onChange={(e) => setEditingDikeyFonName({ ...editingDikeyFonName, value: e.target.value })}
                                autoFocus
                              />
                              <div className="edit-actions">
                                <button
                                  type="button"
                                  className="btn-confirm"
                                  onClick={() => {
                                    const newList = [...dikeyExtras.fonList];
                                    newList[index] = editingDikeyFonName.value;
                                    setDikeyExtras({ ...dikeyExtras, fonList: newList });
                                    handleSaveSettings({ dikeyFonList: newList });
                                    setEditingDikeyFonName({ index: null, value: '' });
                                  }}
                                >
                                  <i className="fas fa-check"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn-delete"
                                  onClick={() => setEditingDikeyFonName({ index: null, value: '' })}
                                >
                                  <i className="fas fa-times"></i>
                                </button>
                              </div>
                            </div>
                          ) : (
                            <>
                              <span className="item-text">{item}</span>
                              <div className="item-actions">
                                <button
                                  type="button"
                                  className="btn-edit"
                                  onClick={() => setEditingDikeyFonName({ index, value: item })}
                                >
                                  <i className="fas fa-edit"></i>
                                </button>
                                <button
                                  type="button"
                                  className="btn-delete"
                                  onClick={() => {
                                    const newList = dikeyExtras.fonList.filter((_, i) => i !== index);
                                    setDikeyExtras({ ...dikeyExtras, fonList: newList });
                                    handleSaveSettings({ dikeyFonList: newList });
                                  }}
                                >
                                  <i className="fas fa-trash-alt"></i>
                                </button>
                              </div>
                            </>
                          )}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      )}
    </>
  );
});

export default DikeySettings;
